// src/components/Spinner.js
import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const Spinner = ({ size, color }) => {
  const { selectedCompany } = useSelector((state) => state?.auth);
  const sizes = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  return (
    <div className={`flex justify-center items-center spinner`}>
      <div
        className={`${sizes[size]} border-4 ml-4 border-gray_100 border-t-transparent border-solid rounded-full animate-spin`}
        style={{ borderTopColor: selectedCompany?.brand_colour }} // Set color dynamically
      ></div>
    </div>
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  color: PropTypes.string,
};

Spinner.defaultProps = {
  size: "md",
  color: "blue",
};

export default Spinner;
